import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { requestForgotPasswordOtp } from '../../services/api';
import { ACTION } from '@kioskgaming/ui';

export default function ForgotPasswordContactPage() {
  const navigate = useNavigate();
  const [contact, setContact] = useState('');
  const [loading, setLoading] = useState(false);

  const onGetOtp = async () => {
    if (!contact.trim()) {
      toast.error('Please enter your email or phone');
      return;
    }
    setLoading(true);
    try {
      const res = await requestForgotPasswordOtp(contact.trim());
      if (!res.success || !res.data?.token) {
        toast.error(res.message || 'Failed to send OTP');
        return;
      }
      toast.success('OTP sent successfully');
      navigate('/forgot-password/otp', {
        state: {
          requestToken: res.data.token,
          contact: contact.trim(),
          nextResendAt: res.data.next_resend_at,
        },
      });
    } catch (error: unknown) {
      const msg =
        (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
        'Failed to send OTP';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-amber-50 px-4 py-8">
      <div className="mx-auto w-full max-w-md rounded-2xl border border-orange-100 bg-white p-6 shadow-xl shadow-orange-100/50">
        <p className="text-center text-xs font-medium uppercase tracking-wide text-orange-600">
          Step 1 of 3
        </p>
        <h1 className="mt-1 text-center text-xl font-bold text-gray-900">Forgot password</h1>
        <p className="mt-2 text-center text-sm text-gray-600">
          Enter the email or phone number registered to your Agent account.
        </p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">Email or phone</label>
            <input
              type="text"
              autoComplete="username"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-500/20"
              placeholder="agent@example.com or +1…"
            />
          </div>
          <button
            type="button"
            onClick={onGetOtp}
            disabled={loading}
            className="w-full rounded-lg bg-orange-600 py-2.5 text-sm font-semibold text-white hover:bg-orange-700 disabled:opacity-60"
          >
            {loading ? 'Sending…' : 'Get OTP'}
          </button>
        </div>

        <Link to="/login" className="mt-6 block text-center text-sm text-orange-700 hover:underline">
          {ACTION.backToSignIn}
        </Link>
      </div>
    </div>
  );
}
